import { render, staticRenderFns } from "./GlebaDeslocada.vue?vue&type=template&id=ea617b62&lang=pug"
import script from "./GlebaDeslocada.vue?vue&type=script&lang=js"
export * from "./GlebaDeslocada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports